import React from "react"
import { ItemDestaque } from "../../../public/CatalogoPage";
import BoxComponent from "../../../../../components/Box/BoxComponent";
import TypographyComponent from "../../../../../components/Typography/ThypographyComponent";
import { formatNumberToDinheiro } from "../../../../../utils/dinheiro";
import ButtonComponent from "../../../../../components/Button/ButtonComponent";
import { ReactComponent as EditIcon } from "../../../../../assets/icons/dashboard/lapis.svg";
import { ReactComponent as TrashIcon } from "../../../../../assets/icons/lixeira.svg";
import SvgComponent from "../../../../../components/Image/SvgComponent";

interface CatalogoAdminItemCardProps {
    item: ItemDestaque;
    onClickEdit: (item: ItemDestaque) => void;
    onClickDelete: (item: ItemDestaque) => void;
}

const CatalogoAdminItemCard = (props: CatalogoAdminItemCardProps) => {
    console.log(props)

    const buttonStyle = {
        width: '159px',
        height: '24px',
        padding: '4px 8px',
        borderRadius: '4px',
        opacity: 1,

        fontFamily: '"Font 7", sans-serif',
        fontWeight: 500,
        fontSize: '12px',
        lineHeight: '16px',
        letterSpacing: '0%',
        textAlign: 'center',
        textTransform: "inherit",
        border: 0,

        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '4px',
        verticalAlign: 'middle',
        boxSizing: 'border-box'
    }

    const handleClickEditarItem = (item: ItemDestaque) => {
        props.onClickEdit(item);
    }

    const handleClickDeleteItem = (item: ItemDestaque) => {
        props.onClickDelete(item);
    }

    const isAtivo = props.item.ativo;
    const midiaAtiva = props.item.midias?.find(m => m.ativo);

    return <BoxComponent component="div" sx={{
        display: "flex",
        flexDirection: "column",
        width: "20%",
        border: "1px solid #E8DFD5",
        backgroundColor: "#F8F5F0",
        borderRadius: "8px"
    }}>
        {/* <BoxComponent component="div" sx={{
            display: "flex",
            flexDirection: "column",
            p: 1.5
        }}>
            SELECIONAR (A DESENVOLVER)
        </BoxComponent> */}
        <BoxComponent component="div" sx={{
            display: "flex",
            flexDirection: "column",
            // maxWidth: "358px",
            // height: "358px"
        }}>
            <BoxComponent component="img"
                sx={{
                    width: "100%",
                    height: "100%",
                    angle: "0 deg",
                    opacity: 1
                }}
                src={midiaAtiva?.caminho}
                alt={`image-${props.item.titulo}`}
            />
        </BoxComponent>
        <BoxComponent component="div" sx={{
            display: "flex",
            flexDirection: "column",
            p: 1.5,
            gap: 1.3
        }}>
            <BoxComponent component="div" sx={{
                display: "flex",
                flexDirection: "column",
                gap: 0
            }}>
                <TypographyComponent variant="h3"
                    sx={{
                        fontFamily: '"Font 7", sans-serif',
                        fontWeight: 600,
                        fontSize: '16px',
                        lineHeight: '24px',
                        letterSpacing: '0%',
                        color: '#2C2C2C',
                        display: 'inline-flex',
                        alignItems: 'center',
                        verticalAlign: 'middle'
                    }}
                >
                    {props.item.titulo}
                </TypographyComponent>
                <TypographyComponent variant="h3"
                    sx={{
                        fontFamily: '"Font 7", sans-serif',
                        fontWeight: 400,
                        fontSize: '14px',
                        lineHeight: '20px',
                        letterSpacing: '0%',
                        color: '#999999',
                        display: 'inline-flex',
                        alignItems: 'center',
                        verticalAlign: 'middle'
                    }}
                >
                    {formatNumberToDinheiro(props.item.precoAtual || 0)}
                </TypographyComponent>
            </BoxComponent>
            <TypographyComponent variant="body2"
                sx={{
                    width: '46px',
                    height: '24px',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    opacity: 1,

                    fontFamily: '"Font 7", sans-serif',
                    fontWeight: 500,
                    fontSize: '12px',
                    lineHeight: '16px',
                    letterSpacing: '0%',

                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    verticalAlign: 'middle',
                    boxSizing: 'border-box',
                    backgroundColor: isAtivo ? "#D1FAE5" : "#FFE2E2",
                    color: isAtivo ? "#016630" : "#DC2626",
                }}
            >
                {isAtivo ? "Ativo" : "Inativo"}
            </TypographyComponent>
            <BoxComponent component="div" sx={{ display: "flex", gap: 2 }}>
                <ButtonComponent
                    id={`editar-item-${props.item.id}`}
                    type="button"
                    variant="outlined"
                    sx={{
                        ...buttonStyle,
                        backgroundColor: "#FF8C42",
                        color: "#FFFFFF"
                    }}
                    onClick={() => handleClickEditarItem(props.item)}
                >
                    <SvgComponent
                        icon={<EditIcon />}
                        sx={{
                            display: "flex",
                            alignpropss: "center",
                            justifyContent: "center",
                            width: 14,
                            height: 14,
                            "& svg, & svg *": {
                                fill: "#FFFFFF",
                            },
                        }}
                    />
                    Editar
                </ButtonComponent>
                <ButtonComponent
                    id={`deletar-item-${props.item.id}`}
                    type="button"
                    variant="outlined"
                    sx={{
                        ...buttonStyle,
                        backgroundColor: "#FFE2E2",
                        color: "#DC2626"
                    }}
                    onClick={() => handleClickDeleteItem(props.item)}
                    disabled={!props.item.ativo}
                >
                    <SvgComponent
                        icon={<TrashIcon />}
                        sx={{
                            display: "flex",
                            alignpropss: "center",
                            justifyContent: "center",
                            width: 14,
                            height: 14,
                            "& svg, & svg *": {
                                stroke: "#DC2626",
                            },
                        }}
                    />
                    Inativar
                </ButtonComponent>
            </BoxComponent>
        </BoxComponent>
    </BoxComponent>
}

export default CatalogoAdminItemCard;